import React, { useState, useEffect } from 'react'

import { BiArrowBack } from "react-icons/bi";
import { MdOutlinePrint } from "react-icons/md";

// react router dom
import { Link, useHistory } from 'react-router-dom';

// components
import ItemsOrdered from './ItemsOrdered';
import Invoices from './Invoices';
import OrderShipments from './OrderShipments';

export default function OrderDetailsView(props) {
    // props
    const { orderDetails } = props

    // consts
    const history = useHistory()

    // states
    const [currentTab, setCurrentTab] = useState("itemsOrdered")

    // on go back press
    const handleBackPress = ev => {
        ev.preventDefault()

        history.goBack() // going back in history
    }

    // when tab changes
    const handleTabChange = (ev, tabName) => {
        ev.preventDefault()

        if (tabName) {
            setCurrentTab(tabName)
        }
    }

    return (
        <div className="order-details-page-main">
            <div className="container">
                <div className="order-details-page-inner">
                    {/* back icon */}
                    <Link to="/" className="back-icon d-flex align-items-center text-decoration-none mb-3" onClick={handleBackPress}>
                        <BiArrowBack fontSize="16" />
                        <span className="ms-2 st-fw-700">Back</span>
                    </Link>

                    <div className="details-container">
                        {
                            <React.Fragment>
                                {/* id */}
                                <p className="order-id d-flex align-items-center mb-3 mb-lg-4">
                                    <span className="st-fw-600">Order #{orderDetails?.orders?.order_id}</span>
                                    {
                                        orderDetails?.orders?.payment_status ? (
                                            <span className="fulfilment-status text-uppercase st-fs-13 st-fw-600 ms-3">
                                                {orderDetails?.orders?.payment_status?.replaceAll("_", " ")}
                                            </span>
                                        ) : null
                                    }
                                </p>

                                {/* date */}
                                <p className="ordered-on mb-3">
                                    <span className="st-fw-600 me-1">Order Date:</span> {orderDetails?.orders?.order_date}
                                </p>

                                {/* order and print */}
                                {/* <div className="reorder-and-print d-flex mb-3">
                                    <p className="reorder mb-0 hover-underline-link cursor-pointer">Reorder</p>
                                    <p className="print ms-auto mb-0 hover-underline-link cursor-pointer d-flex align-items-center" onClick={() => window.print()}>
                                        <MdOutlinePrint />
                                        <span className="ms-1">Print</span>
                                    </p>
                                </div> */}

                                {/* tabs */}
                                <div className="tabs-view mb-4">
                                    {/* head */}
                                    <div className="tabs-head d-flex">
                                        {/* link */}
                                        <div className="tab-link">
                                            <div
                                                href="/"
                                                className={`text-capitalize text-decoration-none text-center cursor-pointer ${(currentTab === "itemsOrdered") ? "active" : ""}`}
                                                onClick={ev => handleTabChange(ev, "itemsOrdered")}
                                            >
                                                items ordered
                                            </div>
                                        </div>

                                        {/* link */}
                                        {/* <div className="tab-link">
                                                <div
                                                    href="/"
                                                    className={`text-capitalize text-decoration-none text-center cursor-pointer ${(currentTab === "invoices") ? "active" : ""}`}
                                                    onClick={ev => handleTabChange(ev, "invoices")}
                                                >
                                                    invoices
                                                </div>
                                            </div> */}

                                        {/* link */}
                                        <div className="tab-link">
                                            <div
                                                href="/"
                                                className={`text-capitalize text-decoration-none text-center cursor-pointer ${(currentTab === "orderShipments") ? "active" : ""}`}
                                                onClick={ev => handleTabChange(ev, "orderShipments")}
                                            >
                                                order shipments
                                            </div>
                                        </div>
                                    </div>

                                    {/* tab content */}
                                    <div className="tabs-content">

                                        {
                                            currentTab === "itemsOrdered" ? (
                                                <React.Fragment>
                                                    <ItemsOrdered
                                                        ordersList={orderDetails.orderItems}
                                                        orderDetails={orderDetails.orders}
                                                    />
                                                </React.Fragment>
                                            ) : null
                                        }

                                        {
                                            currentTab === "invoices" ? (
                                                <React.Fragment>
                                                    <Invoices orderDetails={orderDetails.orders} />
                                                </React.Fragment>
                                            ) : null
                                        }

                                        {
                                            currentTab === "orderShipments" ? (
                                                <React.Fragment>
                                                    <OrderShipments
                                                        orderDetails={orderDetails.orders}
                                                        paymentDetails={orderDetails.payments}
                                                    />
                                                </React.Fragment>
                                            ) : null
                                        }
                                    </div>
                                </div>

                                {/* address details */}
                                <div className="order-address-details mb-3">
                                    {/* header part */}
                                    <div className="header-part border-bottom mb-3 pb-2">
                                        <p className="mb-0 st-fw-600 st-fs-18">Order Information</p>
                                    </div>

                                    {/* content part */}
                                    <div className="content-part d-flex flex-wrap">
                                        {/* frac */}
                                        <div className="frac col-12 col-md-3">
                                            <p className="head text-capitalize st-fw-800 mb-1">shipping address</p>
                                            <p className="info">
                                                <span>
                                                    {`${orderDetails?.orders?.ship_first_name ?? ""} ${orderDetails?.orders?.ship_middle_name ?? ""} ${orderDetails?.orders?.ship_last_name ?? ""}`}
                                                </span> <br />
                                                <span>
                                                    {orderDetails?.orders?.ship_address ?? ""}
                                                </span> <br />
                                                {
                                                    orderDetails?.orders?.ship_address1 ? (
                                                        <React.Fragment>
                                                            <span>
                                                                {orderDetails.orders.ship_address1}
                                                            </span> <br />
                                                        </React.Fragment>
                                                    ) : null
                                                }
                                                <span>
                                                    {orderDetails?.orders?.shipping_city ?? ""}, {orderDetails?.orders?.shipping_state ?? ""} {orderDetails?.orders?.ship_zipcode ?? ""}
                                                </span> <br />
                                                <span>
                                                    {orderDetails?.orders?.shipping_country ?? ""}
                                                </span>
                                            </p>
                                        </div>

                                        {/* frac */}
                                        <div className="frac col-12 col-md-3">
                                            <p className="head text-capitalize st-fw-800 mb-1">shipping method</p>
                                            <p className="info">
                                                {orderDetails?.orders?.shipping_method ?? ""}
                                            </p>
                                        </div>

                                        {/* frac */}
                                        <div className="frac col-12 col-md-3">
                                            <p className="head text-capitalize st-fw-800 mb-1">billing address</p>
                                            <p className="info">
                                                <span>
                                                    {`${orderDetails?.orders?.bill_first_name ?? ""} ${orderDetails?.orders?.ship_middle_name ?? ""} ${orderDetails?.orders?.bill_last_name ?? ""}`}
                                                </span> <br />
                                                <span>
                                                    {orderDetails?.orders?.bill_address ?? ""}
                                                </span> <br />
                                                {
                                                    orderDetails?.orders?.bill_address1 ? (
                                                        <React.Fragment>
                                                            <span>
                                                                {orderDetails.orders.bill_address1}
                                                            </span> <br />
                                                        </React.Fragment>
                                                    ) : null
                                                }
                                                <span>
                                                    {orderDetails?.orders?.billing_city ?? ""}, {orderDetails?.orders?.billing_state ?? ""} {orderDetails?.orders?.bill_zipcode ?? ""}
                                                </span> <br />
                                                <span>
                                                {orderDetails?.orders?.billing_country ?? ""}
                                                </span>
                                            </p>
                                        </div>

                                        {/* frac */}
                                        <div className="frac col-12 col-md-3">
                                            <p className="head text-capitalize st-fw-800 mb-1">payment method</p>
                                            <React.Fragment>
                                                <p className="info st-fs-13 pb-1 border-bottom mb-1">
                                                    <span className="me-2">{orderDetails?.orders?.card_type}</span>
                                                    <span>**** {orderDetails?.orders?.card_last4}</span>
                                                </p>
                                                <p className="info st-fs-13 pb-1 border-bottom mb-1 d-flex">
                                                    <span className="col st-fw-600 me-2">Payment Date</span>
                                                    <span className="col">
                                                        {orderDetails?.payments?.length && orderDetails?.payments[0]?.payment_date}
                                                    </span>
                                                </p>
                                                <p className="info st-fs-13 pb-1 border-bottom mb-1 d-flex">
                                                    <span className="col st-fw-600 me-2">Payment Status</span>
                                                    <span className="col text-capitalize">
                                                        {orderDetails?.orders?.payment_status && orderDetails.orders.payment_status.replaceAll("_", " ").toLowerCase()}
                                                    </span>
                                                </p>
                                            </React.Fragment>
                                        </div>
                                    </div>
                                </div>

                                {/* additional details */}
                                <div className="order-additional-details d-none">
                                    {/* header part */}
                                    <div className="header-part border-bottom mb-3 pb-2">
                                        <p className="mb-0 st-fw-600 st-fs-18">Additional Information</p>
                                    </div>

                                    {/* content part */}
                                    <div className="content-part d-flex flex-wrap">
                                        {/* frac */}
                                        <div className="frac col-12 col-md-3-12 col-md-3">
                                            <p className="head text-capitalize st-fw-800 mb-1">PO Number</p>
                                            <p className="info">
                                                1002001
                                            </p>
                                        </div>

                                        {/* frac */}
                                        <div className="frac col-12 col-md-3-12 col-md-3">
                                            <p className="head st-fw-800 mb-1">Is the order need to be specific date?</p>
                                            <p className="info">
                                                No
                                            </p>
                                        </div>
                                    </div>

                                </div>
                            </React.Fragment>

                            // !Object.keys(orderDetails)?.length ? (
                            // ) : (
                            //     <React.Fragment>
                            //         <p className="no-details text-center">
                            //             No details found
                            //         </p>
                            //     </React.Fragment>
                            // )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
